import type { PageEntry } from '@os/doc';

/** A page's display name: its own, else « Page N » by position (the document never stores localized text, P14). */
export const pageLabel = (t: (key: string, opts?: Record<string, unknown>) => string, page: Pick<PageEntry, 'name'>, index: number): string =>
  page.name.trim() || t('pages.untitled', { n: index + 1 });
